export default {"src":"/_next/static/media/404_Leody.906c3c77.svg","height":241,"width":307};